import { BrowserRouter, Route, Routes } from "react-router-dom";
import About from "./Screens/About";
import CoachShared from "./Screens/CoachShared";
import Coaches from "./Screens/Coaches";
import CoachName from "./Screens/CoachName";
import Home from "./Screens/Home";
import Blog from "./Screens/Blog";
import PlayerShared from "./Screens/PlayerShared";
import Players from "./Screens/Players";
import PlayersName from "./Screens/PlayersName";
import SharedLayout from "./Screens/SharedLayout";
import Error from "./Screens/Error";
import Contact from "./Screens/Contact";
import SinglePost from "./Screens/SinglePost";
import ThankYou from "./Screens/ThankYou";
import Events from "./Screens/Events";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SharedLayout />}>
          <Route index element={<Home />} />
          <Route path="coaches" element={<CoachShared />}>
            <Route index element={<Coaches />} />
            <Route path=":coachname" element={<CoachName />} />
          </Route>
          <Route path="players" element={<PlayerShared />}>
            <Route index element={<Players />} />
            <Route path=":playersname" element={<PlayersName />} />
          </Route>
          <Route path="about-us" element={<About />} />
          <Route path="thank-you" element={<ThankYou />} />
          <Route path="contact-us" element={<Contact />} />
          <Route path="events" element={<Events />} />
          <Route path="blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<SinglePost />} />
          <Route path="*" element={<Error />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
